import $ from 'jquery'

class RoadmapModal {

    constructor() {
        let node = document.getElementById('modal-roadmap');

        this.node = node;

        this.modal = $(node).modal({show: false});

        this.image = node.querySelector('.modal-img');
        this.video = node.querySelector('.modal-video');
        this.title = node.querySelector('.modal-title');
        this.body = node.querySelector('.modal-body');
        // this.footer = node.querySelector('.modal-footer');

        document.addEventListener('click', this, false);
    }

    handleEvent(event) {
        console.log('Modal.handleEvent(event) [event]', event);

        switch (event.type) {
            case 'click':
                break;
        }
    }

    show({title, body, image, is_video = false}) {
        this.clear();

        this.title.innerHTML = title;
        this.body.innerHTML = body;
        this.setImage(image, is_video)

        this.modal.modal('show');
    }

    clear() {
        this.title.innerHTML = '';
        this.body.innerHTML = '';
        this.image.src = '';
        this.video.src = '';
        // this.footer.innerHTML = '';

        this.image.style.display = 'none';
        this.video.style.display = 'none';
    }

    setImage(content, is_video = false) {
        if (!content) {
            return;
        }

        if (is_video) {
            this.video.src = content
            this.video.style.display = 'block';
            this.image.style.display = 'none';
        } else {
            this.image.src = content;
            this.image.style.display = 'block';
            this.video.style.display = 'none';
        }
    }
}

export default RoadmapModal;

